var render, staticRenderFns
import script from "./UIFormItem.vue?vue&type=script&lang=js&"
export * from "./UIFormItem.vue?vue&type=script&lang=js&"
import style0 from "./UIFormItem.vue?vue&type=style&index=0&id=20dd380e&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dd380e",
  null
  
)

export default component.exports